<template>
  <VContainer>
    <VRow justify="center">
      <VCol cols="12" md="8">
        <AppPreloader v-if="loading" />
        <template v-else>
          <div class="vacancy-list-page">
            <div v-if="vacanciesList">
              <MainInfo
                :id="id"
              />
              <Vacancies
                :id="id"
              />
            </div>
          </div>
        </template>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import { ref, toRefs, watch } from '@vue/composition-api';
import useVacanciesList from '@/compositions/useVacanciesList';
import useCompany from '@/compositions/useCompany';
import MainInfo from '../components/VacanciesList/MainInfo.vue';
import Vacancies from '../components/VacanciesList/Vacancies.vue';
import AppPreloader from '../components/AppPreloader.vue';

export default {
  name: 'VacanciesList',
  components: {
    MainInfo, Vacancies, AppPreloader,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { id } = toRefs(props);
    const { vacanciesList, fetchVacanciesList } = useVacanciesList();
    const { company, fetchCompany } = useCompany();
    const loading = ref(true);
    const loadCompany = async () => new Promise((resolve) => {
      watch(vacanciesList, async () => {
        if (!vacanciesList.value?.data?.companyId) {
          return;
        }
        await fetchCompany(vacanciesList.value?.data?.companyId);
        // if (company?.value?.data?.companyTemplateSettings) {
        //   window.location.href = `${process.env.VUE_APP_CAREER_PORTAL_URL}/${company.value.data.id}/qr/${id.value}`;
        //   return;
        // }
        loading.value = false;
        resolve();
      }, { immediate: true, deep: true });
    });

    async function fetch() {
      await fetchVacanciesList(id.value);
      await loadCompany();
    }

    fetch();

    return {
      fetch,
      vacanciesList,
      loading,
    };
  },
};
</script>

<style lang="scss" scoped>
  .vacancy-list-page {
    max-width: 56.25rem;
    margin: 0 auto;
  }
</style>
